import { USER_ACTIONS } from '../actions/userActions';

// Начальное состояние пользовательских данных
const initialState = {
  introCompleted: false,
  // Другие пользовательские данные можно добавить сюда
};

/**
 * Редьюсер для обработки пользовательских действий
 * @param {Object} state - Текущее состояние
 * @param {Object} action - Объект действия Redux
 * @returns {Object} - Новое состояние
 */
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ACTIONS.SET_INTRO_COMPLETED:
      return {
        ...state,
        introCompleted: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer; 